export default __webpack_public_path__ + "files/media/hd-fleet.36b0d293.jpg";